import React, { useState } from "react";
import { Form, Input, Checkbox, Button, Divider, Modal } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useLoginForm } from "../../../../hooks/useLoginForm";
import { useNavigate } from "react-router-dom";

interface IProps {
  screen: string | undefined;
  id: string | undefined;
}

export const FormLogin: React.FC<IProps> = (props: IProps) => {
  const navigate = useNavigate();
  const [modalRecuperarVisible, setModalRecuperarVisible] = useState<boolean>(false);

  const loginHookData = useLoginForm() as any;
  const onFinish = loginHookData.onFinish;
  const errorMsj = loginHookData.errorMsj ?? loginHookData.errormsj;
  const setErrorMsj = loginHookData.setErrorMsj;
  const mensajeError = loginHookData.mensajeError;

  return (
    <div className="d-flex justify-content-center align-self-center w-100">
      <Form
        layout="vertical"
        className="w-100"
        onFinish={(values: any) => onFinish(values, props.screen, props.id)}
      >
        <div className="row g-2">
          <div className="col-12">
            <Form.Item
              style={{ marginBottom: 10 }}
              label={
                <div className="letter-spacing-0px font-size-12px font-family-Montserrat-Regular font-color-000000">
                  Número de identificación
                </div>
              }
              name="user"
              rules={[
                {
                  required: true,
                  message: "Este campo es requerido",
                },
              ]}
            >
              <Input type="number" size="large" />
            </Form.Item>
          </div>
          <div className="col-12">
            <Form.Item
              style={{ marginBottom: 8 }}
              label={
                <div className="no-margin letter-spacing-0px font-size-12px font-family-Montserrat-Regular font-color-000000">
                  Digita tu contraseña
                </div>
              }
              name="password"
              rules={[
                {
                  required: true,
                  message: "Este campo es requerido",
                },
              ]}
            >
              <Input.Password
                size="large"
                className="font-size-12px"
                iconRender={(visible) =>
                  visible ? (
                    <div className="font-size-12px">VER</div>
                  ) : (
                    <div className="font-size-12px">VER</div>
                  )
                }
              />
            </Form.Item>
          </div>
          {errorMsj ? (
            <div className="col-12 px-3 mb-2">
              <div className="row container-error-login align-items-center">
                <div className="col-11 font-color-AD0808 font-size-12px font-family-Montserrat-Regular">
                  {mensajeError}
                </div>
                <button
                  type="button"
                  className="col-1 justify-content-flex-end font-size-12px font-color-AD0808 button-error-login"
                  onClick={() => setErrorMsj && setErrorMsj(false)}
                  style={{ cursor: "pointer" }}
                >
                  x
                </button>
              </div>
            </div>
          ) : null}
          <div className="col-12">
            <Form.Item style={{ marginBottom: 10 }} name="recordar" valuePropName="checked">
              <Checkbox>
                <span className="font-size-12px">Recordar datos de acceso</span>
              </Checkbox>
            </Form.Item>
          </div>
          <div className="col-6">
            <Button
              className="button-blanco-radius font-size-11px w-100"
              onClick={() => navigate("/usuario/registrarUsuario")}
            >
              Registrarse
            </Button>
          </div>
          <div className="col-6 justify-content-flex-end">
            <Button className="button-azul-radius font-size-11px w-100" htmlType="submit">
              Ingresar
            </Button>
          </div>
          <Divider style={{ margin: "10px 0" }} />
          <div className="col-12 d-flex justify-content-center align-items-center text-center mt-1">
            <span className="font-family-Montserrat-Regular font-size-12px pe-1">
              ¿Olvidaste tu contraseña?
            </span>
            <button
              type="button"
              className="login-recuperar-link-btn"
              onClick={() => setModalRecuperarVisible(true)}
            >
              Recupérala AQUÍ
            </button>
          </div>

          <div className="col-12 d-flex justify-content-center text-center mt-3">
            <div>
              <span className="font-family-Montserrat-Regular font-size-10px">Powered by </span>
              <span
                className="font-family-Montserrat-Regular font-size-10px"
                style={{ opacity: 0.5 }}
              >
                Secretaría de innovación Digital
              </span>
            </div>
          </div>
        </div>
      </Form>

      <Modal
        className="modal-recuperar-clave"
        width={440}
        title={
          <div className="d-flex align-items-center">
            <InfoCircleOutlined style={{ color: "#005CC6", fontSize: 20, marginRight: 8 }} />
            <span style={{ fontFamily: "Montserrat-Bold", fontSize: 16 }}>
              Recuperación de contraseña
            </span>
          </div>
        }
        visible={modalRecuperarVisible}
        onCancel={() => setModalRecuperarVisible(false)}
        centered
        footer={[
          <Button
            key="cancelar"
            className="button-gray-ghost"
            onClick={() => setModalRecuperarVisible(false)}
          >
            Cancelar
          </Button>,
          <Button
            key="continuar"
            className="button-azul-radius"
            onClick={() => {
              setModalRecuperarVisible(false);
              window.open("https://www.medellin.gov.co/", "_blank", "noopener,noreferrer");
            }}
          >
            Continuar a medellin.gov.co
          </Button>,
        ]}
      >
        <div className="py-2" style={{ fontSize: "14px", color: "#334155", lineHeight: 1.6 }}>
          <p className="mb-0">
            Vas a ser redirigido al portal <strong>medellin.gov.co</strong> donde se gestiona la recuperación de clave.
          </p>
        </div>
      </Modal>
    </div>
  );
};
